import React from "react";
import { Button } from "../../UI/Button";
import { ReportSubscription } from "../../services/AdminApi";
import { EditAdminNotificationModal } from "./EditAdminNotificationModal";
import { useModalContext } from "../../contexts/ModalContext/context";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";

export interface IProps {
  subscription: ReportSubscription;
  reloadSubscriptions: () => Promise<void>;
}

export const EditAdminNotificationButton: React.FC<IProps> = (props) => {
  const { isOpen, setIsOpen } = useModalContext();

  const openModal = () => setIsOpen(true);

  return (
    <>
      <ReadOnlyWrapper>
        <Button appearance="default" onClick={openModal}>
          Edit
        </Button>
      </ReadOnlyWrapper>
      {isOpen && (
        <EditAdminNotificationModal
          subscription={props.subscription}
          reloadSubscriptions={props.reloadSubscriptions}
        />
      )}
    </>
  );
};
